import React, { useMemo } from 'react'

import parse from 'html-react-parser'

import { BACKEND_MENTION_PATTERN_REG } from 'Constants/Regex'

import { Container } from './styles'

function Description({ value }: { value: string | null | undefined }) {
  const content = useMemo(() => {
    if (!value) return null

    return parse(value, {
      replace(node) {
        if (node.type === 'text') {
          const text = node.data ?? ''

          BACKEND_MENTION_PATTERN_REG.lastIndex = 0

          const parts: React.ReactNode[] = []
          let lastIndex = 0
          let match: RegExpExecArray | null

          while ((match = BACKEND_MENTION_PATTERN_REG.exec(text)) !== null) {
            const [fullMatch, rawName, rawId] = match
            const index = match.index

            if (index > lastIndex) {
              parts.push(text.slice(lastIndex, index))
            }

            parts.push(
              <b key={`${rawId}-${index}`}>@{String(rawName ?? '').trim()}</b>,
            )

            lastIndex = index + fullMatch.length
          }

          if (lastIndex < text.length) {
            parts.push(text.slice(lastIndex))
          }

          if (parts.length === 0) return undefined

          return <>{parts}</>
        }

        return undefined
      },
    })
  }, [value])

  return <Container>{content}</Container>
}

export default Description
